import classes from "./button.module.css";

const DeleteButton = ({onClick}) => {
    return (
        <button
            type="button"
            onClick={onClick}
            aria-label="Удалить"
            className={`${classes.iconBtn} ${classes.delete}`}
        >
            <svg xmlns="http://www.w3.org/2000/svg"
                 width="18" height="18"
                 viewBox="0 0 24 24" fill="currentColor">
                <path d="M9 3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1h4a1 1 0 1 1 0 2h-1v14a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V5H3a1 1 0 1 1 0-2h4zm2 6v8a1 1 0 0 0 2 0V9a1 1 0 0 0-2 0z"/>
            </svg>
        </button>
    )
};

export default DeleteButton;
